import { gql } from '@apollo/client';
import { Order_SmartOrderQuery, Order_SmartOrderQueryVariables } from '@/types';
import { useItemQueryVariables } from './use-item-query-variables';
import { useLazyQuery } from './use-lazy-query';
import { useUserContext } from '@/contexts/user-context';
import { VARIANTS_PACK_FRAGMENT } from '@/contexts/items-context-queries';

export const SMART_ORDER_QUERY = gql`
  fragment SmartOrderResponseFields on GetSmartOrderResponse {
    quantity
    search_term
    variant_pack {
      ...ItemsContext_VariantsPackFields
    }
  }

  query Order_SmartOrder(
    $isRestrictedSearch: Boolean!
    $locale: String!
    $requestedItems: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $supplierUUID: uuid!
  ) {
    getSmartOrderResults(
      requested_items: $requestedItems
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      is_restricted_search: $isRestrictedSearch
    ) {
      ...SmartOrderResponseFields
    }
  }

  ${VARIANTS_PACK_FRAGMENT}
`;

export const useGetSmartOrderResults = () => {
  const itemQueryVariables = useItemQueryVariables();
  const {
    selectedRestaurantRelationship: { supplierUUID },
    selectedRestaurantUUID: restaurantUUID,
  } = useUserContext();

  const getLazySmartOrderResults = useLazyQuery<
    Order_SmartOrderQuery,
    Order_SmartOrderQueryVariables
  >(SMART_ORDER_QUERY, {
    fetchPolicy: 'network-only',
  });

  const getSmartOrderResults = async (
    items: string,
    isRestrictedSearch: boolean,
  ) => {
    return getLazySmartOrderResults({
      variables: {
        ...itemQueryVariables,
        isRestrictedSearch,
        requestedItems: items,
        restaurantUUID,
        supplierUUID,
      },
    });
  };

  return { getSmartOrderResults };
};
